import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { AviaPassengerType } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import { getPassengerTypeLabel } from '../../../../../utils';
import Money from '../../../../../Money';
import { FareBreakdown as FareBreakdownModel } from '../../model/fareBreakdown';

export interface Props {
	className?: string;
	breakdown: FareBreakdownModel;
}

const FareBreakdown: React.FC<Props> = ({ className, breakdown }) => {
	const { t } = useTranslation('DesktopFlightInfo');
	const { FareBreakdown: theme } = useTheme('Entities').Fare;

	if (!breakdown.groups.length) {
		return null;
	}

	return (
		<div className={cn(theme.price__details, className)}>
			{breakdown.groups.map(group => (
				<React.Fragment key={group.groupId}>
					{group.passengers.map(passenger => (
						<div key={passenger.passengerType} className={theme.price__group}>
							<div className={theme.price__label}>
								{passenger.count}{' '}
								{getPassengerTypeLabel(
									passenger.passengerType as AviaPassengerType,
									undefined,
									passenger.count
								)}
							</div>

							<div className={theme.price__item}>
								<span>{t('Tariff')}</span> <Money money={passenger.baseFare} />
							</div>

							<div className={theme.price__item}>
								<span>{t('Taxes')}</span> <Money money={passenger.totalTaxes} />
							</div>
						</div>
					))}
				</React.Fragment>
			))}

			{(!!breakdown.additionalPrices?.length || breakdown.total) && <div className={theme.price__separator} />}

			{breakdown.total && (
				<div className={cn(theme.price__item, theme.price__item_highlighted)}>
					<span>{t('Total')}</span> <Money money={breakdown.total} />
				</div>
			)}

			{breakdown.additionalPrices?.map(item => (
				<div
					key={item.label}
					className={cn(theme.price__item, { [theme.price__item_highlighted]: item.highlighted })}
				>
					<span>{item.label}</span> <Money money={item.price} />
				</div>
			))}
		</div>
	);
};

export default FareBreakdown;
